import Record from "./base"

export class Block extends Record {}



// WEBPACK FOOTER //
// ./src/store/serializers/block.js